import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as React from "react";

import MenuIcon from "@mui/icons-material/Menu";
import { Stack, Tooltip, Typography, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import TableRowsIcon from "@mui/icons-material/TableRows";
import Button from "@mui/material/Button";
import {changeContractDrilldownCS} from "../../contractDrilldownSliceCS";
import QueryFinancialsGridVersionWide from "../LineItems/QueryFinancialsGridVersionWide";
import DynamicHelper from "./DynamicHelper";
// import {changeContractDrilldownCS} from "../contractDrilldownSliceCS";
// import QueryFinancialsGridVersionWide from "./LineItems/QueryFinancialsGridVersionWide";

export default function DynamicHelperPanel() {
    const dispatchData = useDispatch();

    const selectorQfDrawerMode = useSelector(
        (state) => state.contractDrilldownSlcCS.value.QfDrawerMode
    );

    const [clearForm, setClearForm] = useState(false);

    function handleDropdownClick() {
        dispatchData(changeContractDrilldownCS({ QfDrawerMode: "Dropdown" }));
    }

    function handleGridNarrowClick() {
        dispatchData(changeContractDrilldownCS({ QfDrawerMode: "GridNarrow" }));
    }

    function handleGridWideClick() {
        dispatchData(changeContractDrilldownCS({ QfDrawerMode: "GridWide" }));
    }

    return (
        <div>
            <Paper
                elevation={3}
                sx={{
                    height: 700,
                    overflowY: "auto",
                    overflowX: "hidden",
                    p: 2,
                    // pl: 4,
                    mt: 4,
                    width: 1000,
                    boxSizing: "border-box"
                }}
            >
                <DynamicHelper/>
                {/*)}*/}
            </Paper>
        </div>
    );
}